export const ROUTE_CONNECT = '/integrate';
export const ROUTE_FLOWS = `${ROUTE_CONNECT}/flows`;
export const ROUTE_PROJECTS = `${ROUTE_CONNECT}/projects`;
export const ROUTE_SOURCES = `${ROUTE_CONNECT}/sources`;
export const ROUTE_NEXSETS = `${ROUTE_CONNECT}/nexsets`;
export const ROUTE_MY_NEXSETS = `${ROUTE_CONNECT}/nexsets/my_nexsets`;
export const ROUTE_DESTINATIONS = `${ROUTE_CONNECT}/destinations`;
export const ROUTE_CREDENTIALS = `${ROUTE_CONNECT}/tools/credentials`;
export const ROUTE_LOOKUPS = `${ROUTE_CONNECT}/tools/lookups`;
export const ROUTE_SCHEMA_SPECS = `${ROUTE_CONNECT}/tools/schemaSpecs`;
export const ROUTE_REUSABLE_TRANSFORMS = `${ROUTE_CONNECT}/tools/transforms`;
export const ROUTE_API_KEYS = `${ROUTE_CONNECT}/tools/apiKeys`;

export const ROUTE_DISCOVER = '/discover';
export const ROUTE_MONITOR = '/monitor';
/**
 * Stable, routing-agnostic entry point for emailed/Slack triage deep links.
 * Notifications point here forever; the handler translates the link's context
 * params into a redirect + triage modal, so future routing/behavior changes
 * touch only the handler — never the sent link.
 */
export const ROUTE_TRIAGE_LINK = `${ROUTE_MONITOR}/triage`;
export const ROUTE_SETTINGS = '/settings';
export const ROUTE_SETTINGS_CAPSULES = `${ROUTE_SETTINGS}/capsules`;
/** Route pattern for React Router (param name: `capsuleId`). */
export const ROUTE_SETTINGS_CAPSULE_DETAIL = `${ROUTE_SETTINGS_CAPSULES}/:capsuleId`;

export function buildSettingsCapsuleDetailPath(capsuleId: string): string {
  return `${ROUTE_SETTINGS_CAPSULES}/${encodeURIComponent(capsuleId)}`;
}
export const ROUTE_SETTINGS_USER_SLUG = '/user';
export const ROUTE_SETTINGS_USER = `${ROUTE_SETTINGS}${ROUTE_SETTINGS_USER_SLUG}`;
export const ROUTE_SETTINGS_SECURITY_SLUG = '/security';
export const ROUTE_DATA_CUSTODIANS = `${ROUTE_SETTINGS}/data-custodians`;
export const ROUTE_SETTINGS_AUTHENTICATION = `${ROUTE_SETTINGS}/authentication`;

export const ROUTE_MARKETPLACE = '/marketplace';
export const ROUTE_DATA_PRODUCTS = `${ROUTE_MARKETPLACE}/data-products`;
export const ROUTE_ACCESS_REQUESTS = `${ROUTE_MARKETPLACE}/access-requests`;
export const ROUTE_LISTING_REQUESTS = `${ROUTE_MARKETPLACE}/listing-requests`;
export const ROUTE_DATA_DOMAINS = `${ROUTE_MARKETPLACE}/data-domains`;
export const ROUTE_ENABLE_MARKETPLACE = `${ROUTE_MARKETPLACE}/enable-marketplace`;

export const ROUTE_TASKS = '/tasks';
export const ROUTE_SQL_AUTOMATIONS = `${ROUTE_TASKS}/sql-automations`;

export const ROUTE_AI = '/ai';
export const ROUTE_AI_TOOLS = `${ROUTE_AI}/tools`;
export const ROUTE_AI_TOOL_SETS = `${ROUTE_AI}/toolsets`;
export const ROUTE_AI_MCP = `${ROUTE_AI}/mcp`;
export const ROUTE_AI_MCP_FLOWS = `${ROUTE_AI}/mcp-flows`;
// Temporarily unused routes (for future use)
export const ROUTE_AI_RECEIPTS = `${ROUTE_AI}/receipts`;
export const ROUTE_AI_GOVERNANCE = `${ROUTE_AI}/governance`;

export const ROUTE_COLLABORATE = '/collaborate';
export const ROUTE_COLLABORATE_DASHBOARD = `${ROUTE_COLLABORATE}/dashboard`;
export const ROUTE_COLLABORATE_360 = `${ROUTE_COLLABORATE}/resource-sharing`;
export const ROUTE_ACCESS_INSIGHTS = `${ROUTE_COLLABORATE}/access-insights`;
export const ROUTE_RESOURCES_360 = `${ROUTE_COLLABORATE}/resources360`;
export const ROUTE_PEOPLE_360 = `${ROUTE_COLLABORATE}/people360`;
export const ROUTE_COLLABORATE_ORG = `${ROUTE_COLLABORATE}/org`;
export const ROUTE_COLLABORATE_USER = `${ROUTE_COLLABORATE}/user`;
export const ROUTE_COLLABORATE_SHARED_USERS = `${ROUTE_COLLABORATE}/shared_users`;
export const ROUTE_COLLABORATE_TEAM = `${ROUTE_COLLABORATE}/team`;
export const ROUTE_COLLABORATE_TEAM_ID = `${ROUTE_COLLABORATE}/team/:id`;
export const ROUTE_COLLABORATE_RESOURCE_ID = `${ROUTE_COLLABORATE}/resource`;
export const ROUTE_COLLABORATE_TEAM_DETAIL = (id: string) => `${ROUTE_COLLABORATE_TEAM}/${id}`;
export const ROUTE_COLLABORATE_ORG_DETAIL = (name: string, id: string) =>
  `${ROUTE_COLLABORATE_ORG}/${name}?orgId=${id}`;
export const ROUTE_COLLABORATE_USER_DETAIL = (name: string, id: string) =>
  `${ROUTE_COLLABORATE_USER}/${name}?userId=${id}`;

export const EXPRESS_URL = 'https://www.express.dev';
export const ROUTE_EXPRESS = '/express';
